import React, { useState, useEffect, useContext } from "react";
import { Container, Spinner } from "react-bootstrap";
import ActionComp from "../layouts/ActionComp";
import BreadcrumbComp from "../layouts/BreadcrumbComp";
import GridMaster from "./GridMaster";
import StatusRenderer from "./StatusRenderer.jsx";
import ActionRenderer from "./ActionRenderer";
import { DeleteUser, getAllUsers, UpdateUserStatus } from "../../services/user-service";
import { exportToExcel } from "../utils/ExcelCreation";
import { getCurrentDateTime, formatDateInDDMMYYYY, formatDateInYYYYMMDD } from "../../functions/common-functions.js";
import AddEditUserMaster from "./AddEditUserMaster";
import { useDispatch } from "react-redux";
import { menuActions } from "../../store/menu-slice";
import { searchActions } from "../../store/grid-slice";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import escapeExcelData from "../utils/customValidation.js";
import { getUserInitials, sortByPropertyInAscending } from "../../utils/Utility";
import { AuthContext } from "../../contexts/AuthContext";
import { addLogDetails } from "../../services/logger-entry-service";
import { ALERT_PARAMS } from "../../utils/constant.js";

const UserMaster = () => {
  const MySwal = withReactContent(Swal);
  const context = useContext(AuthContext);
  const userDetails = { email: context.userEmail, userName: context.userName, role: context.role, userId: context.userId }
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [filteredResulttemp, setFilteredResulttemp] = useState([]);
  const [filterColLength, setFilterColLength] = useState(0);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [resetFilter, setResetFilter] = useState(true);
  const [loading, setLoading] = useState(true);

  const AvatarCellRenderer = (params) => {
    let initials = getUserInitials(params.value);
    return (
      <div className="user-name-initials">
        <div className={"user-initials user-initials-color"}>
          <span>{initials}</span>
        </div>
        <div className="user-info">
          <span className="user-name">{params.value}</span>
        </div>
      </div>)
  }

  const dispatch = useDispatch();
  dispatch(menuActions.setMenu("User Master"));

  const columnDefs = [
    {
      headerName: "Status",
      field: "DeleteIndication",
      flex: false,
      maxWidth: 130,
      resizable: false,
      tooltipField: "DeleteIndication",
      cellRenderer: StatusRenderer,
      sort: 'asc'
    },
    {
      headerName: "User Type",
      field: "UserType",
      minWidth: 150,
      tooltipField: "UserType",
    },
    {
      headerName: "User ID",
      field: "UserId",
      tooltipField: "UserId",
      minWidth: 130,
      sort: 'asc'
    },
    {
      headerName: "User Name",
      field: "UserName",
      minWidth: 200,
      tooltipField: "UserName",
      cellRenderer: AvatarCellRenderer
    },
    {
      headerName: "Role",
      field: "RoleDescription",
      minWidth: 180,
      tooltipField: "RoleDescription",
    },
    {
      headerName: "Division",
      field: "Division",
      minWidth: 120,
      tooltipField: "Division",
    },
    {
      headerName: "Location",
      field: "Location",
      minWidth: 180,
      tooltipField: "Location",
    },
    {
      headerName: "BP Code",
      field: "BPCode",
      minWidth: 150,
      tooltipField: "BPCode",
    },
    {
      headerName: "Email ID",
      field: "EmailId",
      minWidth: 150,
      tooltipValueGetter: (params) => escapeExcelData(params.data.EmailId, true),
      valueFormatter: (params) => {
        return escapeExcelData(params.data.EmailId, true);
      },
    },
    {
      headerName: "Mobile Number",
      field: "MobileNo",
      minWidth: 150,
      tooltipValueGetter: (params) => escapeExcelData(params.data.MobileNo, true),
      valueFormatter: (params) => {
        return escapeExcelData(params.data.MobileNo, true);
      },
    },
    {
      headerName: "Alternate Mobile Number",
      field: "AlternateMobileNo",
      minWidth: 150,
      tooltipField: "AlternateMobileNo",
      tooltipValueGetter: (params) => escapeExcelData(params.data.AlternateMobileNo, true),
      valueFormatter: (params) => {
        return escapeExcelData(params.data.AlternateMobileNo, true);
      },
    },
    {
      headerName: "Inserted By",
      field: "CreatedByName",
      minWidth: 150,
      tooltipField: "CreatedByName",
    },
    {
      headerName: "Inserted On",
      field: "CreatedOn",
      minWidth: 150,
      tooltipField: "CreatedOn",
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        return params.value ? formatDateInDDMMYYYY(params.value) : "";
      },
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const dateAsString = cellValue;
          if (dateAsString == null) {
            return 0;
          }
          const dateCell = new Date(formatDateInYYYYMMDD(cellValue) + " 00:00:00");

          if (dateCell < filterLocalDateAtMidnight) {
            return -1;
          } else if (dateCell > filterLocalDateAtMidnight) {
            return 1;
          }
          return 0;
        },
      },
    },
    {
      headerName: "Modified By",
      field: "ModifiedByName",
      minWidth: 150,
      tooltipField: "ModifiedByName",
    },
    {
      headerName: "Modified On",
      field: "ModifiedOn",
      minWidth: 150,
      tooltipField: "ModifiedOn",
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        return params.value ? formatDateInDDMMYYYY(params.value) : "";
      },
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const dateAsString = cellValue;
          if (dateAsString == null) {
            return 0;
          }
          // In the example application, dates are stored as dd/mm/yyyy
          // We create a Date object for comparison against the filter date
          const dateCell = new Date(formatDateInYYYYMMDD(cellValue) + " 00:00:00");

          if (dateCell < filterLocalDateAtMidnight) {
            return -1;
          } else if (dateCell > filterLocalDateAtMidnight) {
            return 1;
          }
          return 0;
        },
      },
    },
    context.menuName.includes("User Master") ?
      {
        field: "",
        maxWidth: 80,
        sortable: false,
        filter: false,
        pinned: 'right',
        resizable: false,
        cellRenderer: function (params) {
          return <ActionRenderer selectedData={params.data} handleEditEvent={handleEdit} handleDeleteEvent={handleDelete} />
        },
      } : {},
  ];

  const headerName = (field) => {
    let name;
    switch (field) {
      case "DeleteIndication":
        name = "Status";
        break;
      case "UserType":
        name = "User Type";
        break;
      case "UserId":
        name = "User ID";
        break;
      case "UserName":
        name = "User Name";
        break;
      case "RoleDescription":
        name = "Role";
        break;
      case "Division":
        name = "Division";
        break;
      case "Location":
        name = "Location";
        break;
      case "BPCode":
        name = "BP Code";
        break;
      case "EmailId":
        name = "Email ID";
        break;
      case "MobileNo":
        name = "Mobile Number";
        break;
      case "AlternateMobileNo":
        name = "Alternate Mobile Number";
        break;
      case "CreatedByName":
        name = "Inserted By";
        break;
      case "CreatedOn":
        name = "Inserted On";
        break;
      case "ModifiedByName":
        name = "Modified By";
        break;
      case "ModifiedOn":
        name = "Modified On";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const fieldName = (header) => {
    let name;
    switch (header) {
      case "Status":
        name = "DeleteIndication";
        break;
      case "User Type":
        name = "UserType";
        break;
      case "User ID":
        name = "UserId";
        break;
      case "User Name":
        name = "UserName";
        break;
      case "Role":
        name = "RoleDescription";
        break;
      case "Division":
        name = "Division";
        break;
      case "Location":
        name = "Location";
        break;
      case "BP Code":
        name = "BPCode";
        break;
      case "Email ID":
        name = "EmailId";
        break;
      case "Mobile Number":
        name = "MobileNo";
        break;
      case "Alternate Mobile Number":
        name = "AlternateMobileNo";
        break;
      case "Inserted By":
        name = "CreatedByName";
        break;
      case "Inserted On":
        name = "CreatedOn";
        break;
      case "Modified By":
        name = "ModifiedByName";
        break;
      case "Modified On":
        name = "ModifiedOn";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const fetchUserMaster = async () => {
    setLoading(true);
    dispatch(searchActions.setSearch(""));

    const result = await getAllUsers();

    result?.sort(sortByPropertyInAscending("DeleteIndication")).sort((a, b) => {
      if (a.DeleteIndication === b.DeleteIndication) {
        return sortByPropertyInAscending("UserId")(a, b);
      }
      return 0;
    });
    setFilteredResult(result);
    setExcelData(result);
    setResetFilter(!resetFilter);
    setLoading(false);
  };


  useEffect(() => {
    fetchUserMaster();
  }, [reload]);

  const handleView = async (row) => {
    setLoading(true);
    setAction("View");
    setRowData(row);
    setShowForm(true);
    setLoading(false);
  }

  const handleEdit = async (row) => {
    setLoading(true);
    let tempUnique = "SK#" + row.SK;
    await addLogDetails(row, "View", tempUnique, "UserMasterLog", userDetails, "Master");
    setAction("Edit");
    setRowData(row);
    setShowForm(true);
    setLoading(false);
  }

  const handleDelete = async (params) => {
    let result;
    let tempUnique = "SK#" + params.SK;
    let userName = params.UserName;

    // Check if logged in user is trying to delete themselves
    if (params.UserId === userDetails.userId) {
      MySwal.fire({
        text: "User is logged in user. Cannot delete.",
        imageUrl: errorImage,
        customClass: "swal-success",
      });
      return;
    }

    MySwal.fire({
      text: "Are you sure, do you want to delete User " + userName + "?",
      confirmButtonText: "Delete",
      title: "Delete User",
      ...ALERT_PARAMS
    }).then(async (result2) => {
      if (result2.isConfirmed) {
        setLoading(true);

        // Change status to Inactive instead of permanent deletion
        let userObj = { ...params };
        let todayDate = getCurrentDateTime("-");
        userObj.ModifiedBy = userDetails.userId;
        userObj.ModifiedByName = userDetails.userName;
        userObj.ModifiedOn = todayDate;
        userObj.DeleteIndication = "Inactive";

        result = UpdateUserStatus(userObj);
        result.then(async (resp) => {
          if (resp.status) {
            await addLogDetails(params, "Delete", tempUnique, "UserMasterLog", userDetails, "Master");
            setLoading(false);
            MySwal.fire({
              text: "User status changed to Inactive.",
              imageUrl: successImage,
              customClass: "swal-success",
              didClose: () => {
                setReload(!reload);
              },
            });
          } else {
            setLoading(false);
            MySwal.fire({
              text: "Unable to process request.",
              imageUrl: errorImage,
              customClass: "swal-success",
            });
          }
        })
          .catch((error) => {
            setLoading(false);
            MySwal.fire({
              text: "Unable to process request.",
              imageUrl: errorImage,
              customClass: "swal-success",
            });
          });
      }
    });
  }

  const handleGlobalExport = async () => {
    let filename = "UserMaster";
    let excelDownoadData = [];
    console.log("handleGlobalExport Step 01");
    excelData.forEach(element => {
      excelDownoadData.push({
        DeleteIndication: element.DeleteIndication,
        UserType: element.UserType,
        UserId: element.UserId,
        UserName: element.UserName,
        RoleDescription: element.RoleDescription,
        Division: element.Division,
        Location: element.Location,
        BPCode: element.BPCode,
        EmailId: escapeExcelData(element.EmailId, true),
        MobileNo: escapeExcelData(element.MobileNo, true),
        AlternateMobileNo: escapeExcelData(element.AlternateMobileNo, true),
        CreatedByName: element.CreatedByName,
        CreatedOn: element.CreatedOn ? formatDateInDDMMYYYY(element.CreatedOn.toString()) : "",
        ModifiedByName: element.ModifiedByName,
        ModifiedOn: element.ModifiedOn ? formatDateInDDMMYYYY(element.ModifiedOn.toString()) : ""
      });
    });

    let colName = ["Status", "User Type", "User ID", "User Name", "Role", "Division", "Location", "BP Code", "Email ID", "Mobile Number", "Alternate Mobile Number", "Inserted By", "Inserted On", "Modified By", "Modified On"];
    let Fieldname = ["DeleteIndication", "UserType", "UserId", "UserName", "RoleDescription", "Division", "Location", "BPCode", "EmailId", "MobileNo", "AlternateMobileNo", "CreatedByName", "CreatedOn", "ModifiedByName", "ModifiedOn"];
    exportToExcel(filename, "Data", excelDownoadData, "A1:N1", colName, Fieldname);
  };

  const handleAdd = () => {
    setAction("Add");
    setShowForm(true);
  };

  return (
    <>
      {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
      <BreadcrumbComp />
      <Container fluid className="main-container">
        <ActionComp
          label={"Add New User"}
          exportEvent={() => handleGlobalExport()}
          handleAdd={handleAdd} />

        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          getDataEvent={(getFilteredData) => setFilteredResulttemp(getFilteredData)}
          getFilterColLength={(getLength) => setFilterColLength(getLength)}
          setExcelData={setExcelData}
          handleView={handleView}
          handleEdit={handleEdit}
          openConfirmBox={handleDelete}
          resetind={resetFilter}
        />

        {showForm && (
          <AddEditUserMaster
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            setReload={setReload}
            reload={reload}
          />
        )}
      </Container>
    </>
  );
};

export default UserMaster;
